import { ReactNode } from "react";
import { Typography } from "@mui/material";
import styles from "./OptionCard.module.css";

export default function OptionCard({
	title,
	platformIcon,
	children,
}: {
	title: ReactNode;
	platformIcon?: ReactNode;
	children: ReactNode;
}) {
	return (
		<li className={styles.optionCard}>
			{platformIcon}
			<Typography component="h2" className={styles.cardTitle}>{title}</Typography>
			{children}
		</li>
	);
}

export function SetupOptionList({ children }: { children: ReactNode }) {
	return <ul className={styles.optionList}>{children}</ul>;
}
